export default "__VITE_ASSET__xPQYDZXj__"